
import React, { useRef, useState } from 'react';
import { Image, Dropdown, Menu } from "antd";
import customStyles from "../../../../assets/styles/customStyles";
import clsx from 'clsx';
import { NavLink } from "react-router-dom";
import hamburgerMenu from "../../../../assets/images/icon_actions/hamburgerMenu.svg";
import { exportChatFile } from "../../../../helpers/utilities";
import { TextField } from "@mui/material";
import SearchIcon from "../../../../assets/images/icon_actions/Search Icon.svg";
import { ClientListTable } from "./ClientListTable";

export const ClientList = (props) => {
    const { title, details, loadMore,
        loadMoreTask, loadMoreContent,
        requestSort, sortOrder, sortBy, dispatchFilter, handleSearch } = props;

    const clientList = useRef(null);
    const [iconAnimation, setIconAnimation] = useState(false);

    const classes = customStyles();

    const handleImageDownload = (type) => {
        if (type === 'csv') {
            exportFile();
        } else {
            //downloadImageCommon(netGST.current, title, type);
        }
    }


    const exportFile = () => {
        let newHead = [['Top Area Sales Total', 'Top City Sales Total', 'Sales Total']];
        exportChatFile(title, newHead);
    }

    return (
        <div ref={clientList} style={{ height: "100%" }}>
            <div className={clsx(classes.monthlyDiv, classes.clientList)} style={{ height: "100%" }}>
                <div className={clsx(classes.monthlyDivTitle, classes.bold)}>
                    {`${title}`}
                    <span className={classes.hamburgerMenu}>
                        <Dropdown
                            placement="bottomLeft"
                            trigger={['click']}
                            overlay={
                                <Menu className={clsx(classes.groupMenu, classes.hamburgeGroupMenu)}>
                                    <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('png')}>Download PNG</NavLink></Menu.Item>
                                    <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('csv')}>Download CSV</NavLink></Menu.Item>
                                </Menu>
                            }>
                            <Image src={hamburgerMenu} preview={false} />
                        </Dropdown>
                    </span>
                </div>
                <div className={clsx(classes.searchAnimation, classes.margin10t, { [classes.iconAnimation]: iconAnimation })}>
                    <TextField autoComplete='one-time-code'
                        placeholder='Search'
                        type='search'
                        fullWidth
                        onChange={(e) => handleSearch(e.target.value)}
                        className={classes.comInput}
                        variant={'standard'}
                        onFocus={() => setIconAnimation(true)}
                        onBlur={() => setIconAnimation(false)}
                    />
                    <Image
                        src={SearchIcon}
                        preview={false}
                    />
                </div>
                <div className={classes.tableRoot}>
                    <ClientListTable
                        loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                        details={details}
                        loadMore={loadMore}
                        loadMoreTask={() => loadMoreTask()}
                        loadMoreContent={loadMoreContent}
                        sortOrder={sortOrder} sortBy={sortBy}
                        onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}
                    />
                </div>
            </div>
        </div>

    );
}